import api from "@/plugins/axios";
import router from "@/router/index";
import { useGlobalStore } from "@/stores";

const actions = () => ({
  async createSimpleBeneficiary(payload) {
    const res = await api.post("/api/beneficiary/simple/create", payload);
    if (payload.cv) {
      const formData = new FormData();
      formData.append("file", payload.cv);

      await api.post(`/api/files/${res.data}/upload/cv`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    }
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "The beneficiary has been successfully created",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    router.push("/beneficiary/overview");
  },

  async handleFavoriteStatus(payload) {
    const response = await api.post(`/api/beneficiary/${payload.id}/favorite`);
    if (response.status === 200) {
      const globalStore = useGlobalStore();
      globalStore.showSnackbar({
        show: true,
        text: "All changes have been saved!",
        timeout: 3000,
        type: "success",
        position: "top",
      });
    }
    return response;
  },

  async editBeneficiary(payload) {
    await api.post(`/api/beneficiary/${payload.id}`, payload.data);
    if (payload.file) {
      const formData = new FormData();
      formData.append("file", payload.file);

      await api.post(`/api/files/${payload.id}/upload/cv`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    }

    if (payload.photo) {
      const formData = new FormData();
      formData.append("file", payload.photo);

      await api.post(`/api/files/${payload.id}/upload/photo`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    }

    const newData = await this.getBeneficiary({ id: payload.id });

    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "All changes have been saved!",
      timeout: 3000,
      type: "success",
      position: "top",
    });

    return newData;
  },

  async deleteBeneficiary(payload) {
    console.log(`payload data = ${JSON.stringify(payload)}`);
    const response = await api.post(
      `/api/beneficiary/${payload.id}/delete`,
      payload
    );

    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "All changes have been saved!",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    return response;
  },

  async getBeneficiariesOverview(payload) {
    const res = await api.get("/api/beneficiary/overview", {
      params: payload,
    });
    this.overview = res.data.content;
    this.pagination.totalItems = res.data.totalElements;
    this.pagination.cuurentPage = res.data.number + 1;
    this.pagination.pageCount = res.data.totalPages;
  },

  async getBeneficiariesDashboard() {
    const res = await api.get("/api/embed/dashboard/4");

    return res.data;
  },

  async getProjectsReports() {
    const res = await api.get("/api/embed/dashboard/6");

    return res.data;
  },

  async downloadExcel(payload) {
    try {
      const response = await api.get("/api/beneficiary/overview/export", {
        params: payload,
        responseType: "blob",
      });

      return response;
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  },

  async getBeneficiary(payload) {
    const res = await api.get(`/api/beneficiary/${payload.id}`);
    return res.data;
  },

  async fetchCVFile(filename, type = 'cv') {
    const response = await api.get(`/api/files/${filename}`, {
      params: { type },
      responseType: "blob",
    });
    return response;
  },

  async checkEmailExists(email, excludeId = null) {
    try {
      const params = { email };
      if (excludeId) {
        params.excludeId = excludeId;
      }
      const res = await api.get("/api/beneficiary/check-email", {
        params,
      });
      return res.data;
    } catch (error) {
      console.error("Error checking email:", error);
      return { exists: false };
    }
  },

  resetAction() {
    this.filters.keyword = null;
    this.filters.advanced = {
      name: null,
      status: [],
      emplOfficerId: [],
      academyOfficerId: [],
      telephone: null,
      email: null,
      countries: [],
      legalStatus: [],
      gender: [],
      regDates: [],
      matchedCompanies: [],
      coursesEnrolled: null,
      coursesCompleted: null,
      employabilities: null,
      livelihoods: null,
      route: null,
      sourceChannel: null,
      branch: null,
      isFavorite: null,
      projects: [],
      exclude: false,
      primaryLikedProfession: null,
      secondaryLikedProfession: null,
    };
  },
});

export default actions;
